import React from "react";
import PropTypes from "prop-types";
import Icon from "common/components/svg_icon";
import { TABS_MAP } from "your_projects/constants";

const HeaderButtons = ({ toggleRightDrawer, params }) => {
  if (!TABS_MAP?.[params.userType]?.[params.projectType]?.showControls) {
    return null;
  }

  return (
    <div className="hide-for-large button-wrapper">
      <button
        type="button"
        onClick={toggleRightDrawer}
        className="btn btn-icon-only btn-filter header-btn-filter"
      >
        <Icon extraClasses="svg-icon-lg filter" icon="filter" />
      </button>
    </div>
  );
};

HeaderButtons.propTypes = {
  toggleRightDrawer: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default HeaderButtons;
